module.exports = __webpack_public_path__ + "img/P2-C6.6a28196f.svg";